export default __webpack_public_path__ + "static/media/jti.24e85615.svg";